"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Mask = void 0;
var _react = _interopRequireWildcard(require("react"));
var _noScroll = _interopRequireDefault(require("no-scroll"));
var _emotion = require("@instructure/emotion");
var _ensureSingleChild = require("@instructure/ui-react-utils/lib/ensureSingleChild.js");
var _omitProps = require("@instructure/ui-react-utils/lib/omitProps.js");
var _styles = _interopRequireDefault(require("./styles"));
var _theme = _interopRequireDefault(require("./theme"));
var _props = require("./props");
var _MaskCounter = _interopRequireDefault(require("./MaskCounter"));
var _dec, _class, _Mask;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
/**
---
category: components/utilities
---
**/
let Mask = exports.Mask = (_dec = (0, _emotion.withStyle)(_styles.default, _theme.default), _dec(_class = (_Mask = class Mask extends _react.Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleElementRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
    // It can be a ref for any type of child
    this._content = void 0;
    this.contentRef = el => {
      this._content = el;
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
    if (this.props.fullscreen) {
      _noScroll.default.on();
      _MaskCounter.default.incrementCounter();
    }
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  componentWillUnmount() {
    if (this.props.fullscreen) {
      _MaskCounter.default.decrementCounter();
      if (_MaskCounter.default.getCounter() <= 0) {
        _noScroll.default.off();
      }
    }
  }
  render() {
    var _this$props$styles;
    const content = (0, _ensureSingleChild.ensureSingleChild)(this.props.children, {
      ref: this.contentRef
    });
    const props = {
      ...(0, _omitProps.omitProps)(this.props, Mask.allowedProps),
      css: (_this$props$styles = this.props.styles) === null || _this$props$styles === void 0 ? void 0 : _this$props$styles.mask,
      ref: this.handleElementRef
    };
    if (typeof this.props.onClick === 'function') {
      props.onClick = this.props.onClick;
      props.tabIndex = -1;
    }
    return (0, _emotion.jsx)("span", props, content);
  }
}, _Mask.displayName = "Mask", _Mask.componentId = 'Mask', _Mask.allowedProps = _props.allowedProps, _Mask.propTypes = _props.propTypes, _Mask.defaultProps = {
  placement: 'center',
  fullscreen: false
}, _Mask)) || _class);
var _default = exports.default = Mask;